import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import TabsWithTablesLayout from 'src/components/Layout/TabsWithTablesLayout';
import { useTenantContext } from 'src/context/useTenantContext';

interface InventoryPageProps {}

const InventoryPage = React.memo((_: InventoryPageProps) => {
  const { t } = useTranslation();
  const { buildPath } = useTenantContext();
  const routes = [
    { label: t('common.inventoryItems'), url: buildPath('inventory/items') },
    { label: t('common.inventoryMovements'), url: buildPath('inventory/movements') },
    { label: t('common.settings'), url: buildPath('inventory/categories') },
  ];

  return (
    <TabsWithTablesLayout
      homeUrl={'/dashboard/inventory'}
      mainPageUrl={'/inventory/items'}
      routes={routes}
      title={t('common.inventory')}
    >
      <Outlet />
    </TabsWithTablesLayout>
  );
});

export default InventoryPage;
